import { Injectable } from '@angular/core';
import { ApiEnvironment, RuntimeEnvironment } from '@lx/shared/types';
import { BaseConfigService } from '@lx/shared/app-config';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigurationService extends BaseConfigService {
  protected fetchApiEnvironment(environment?: RuntimeEnvironment): ApiEnvironment {
    return {
      API_BASE_PATH: environment.API_BASE_PATH,
    };
  }
}
